// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
import type {
  ISearchRegionsCitiesRequest,
  TSearchRegionsCitiesModel,
  IMappers,
  TSearchRegionsCitiesResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { ISearchRegionCitiesResponse } from '../../entities/response/SearchRegionCitiesResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createSearchRegionsCitiesModel(parameters: ISearchRegionsCitiesRequest): TSearchRegionsCitiesModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'geo-temp-layer',
    pathApi: '/v1/search-regions-cities/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface ISearchRegionsCitiesOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: ISearchRegionsCitiesRequest;
}

export async function fetchSearchRegionsCities<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ISearchRegionsCitiesOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TSearchRegionsCitiesResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createSearchRegionsCitiesModel(parameters),
    config,
  )) as FetchResponse<TSearchRegionsCitiesResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ISearchRegionCitiesResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TSearchRegionsCitiesResponse>;
}
